import React from 'react';

import { SubRouterProps } from '../shared/types';
import { Router } from './components';

// Point d'entrée du module Listes
const Listes: React.FC<SubRouterProps> = ({ sourceStructureNode, ...rest }: SubRouterProps) => {
    return <Router {...rest} sourceStructureNode={sourceStructureNode} />;
};

export default Listes;
